/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FolderCheckIcon16Light } from './FolderCheckIcon16Light';
import { FolderCheckIcon16Regular } from './FolderCheckIcon16Regular';
import { FolderCheckIcon16Solid } from './FolderCheckIcon16Solid';
import { FolderCheckIcon20Light } from './FolderCheckIcon20Light';
import { FolderCheckIcon20Regular } from './FolderCheckIcon20Regular';
import { FolderCheckIcon20Solid } from './FolderCheckIcon20Solid';
import { FolderCheckIcon24Regular } from './FolderCheckIcon24Regular';
import { FolderCheckIcon24Solid } from './FolderCheckIcon24Solid';
import { FolderCheckIcon32Regular } from './FolderCheckIcon32Regular';
import { FolderCheckIcon64Regular } from './FolderCheckIcon64Regular';
var sizes = {
    16: {
        light: FolderCheckIcon16Light,
        regular: FolderCheckIcon16Regular,
        solid: FolderCheckIcon16Solid,
    },
    20: {
        light: FolderCheckIcon20Light,
        regular: FolderCheckIcon20Regular,
        solid: FolderCheckIcon20Solid,
    },
    24: {
        regular: FolderCheckIcon24Regular,
        solid: FolderCheckIcon24Solid,
    },
    32: {
        regular: FolderCheckIcon32Regular,
    },
    64: {
        regular: FolderCheckIcon64Regular,
    },
};
export var FolderCheckIcon = forwardRef('FolderCheckIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
